import React, { useEffect, useState } from "react";

//** Context */
import { useAutocompleteAddress } from "../../../hooks/dataHooks/useGetHarmonyAddressMutation.js";
import { useFindSuburb } from "../../../hooks/dataHooks/useGetHarmonyFindSuburb.js";

//** MUI Components */
import { Typography } from "@mui/material";

//** NDBX Components */
import { OneColumnStack, Section } from "@arp/react-ndbx";

//** Config */
import {
	streetNumberType,
	streetNameType,
} from "../../../config/dropdownSelectValues/selectValues.js";

//** MOVE TO COMPONENT LIBRARY */
import RHFAutocomplete from "../../coding/rhfAutocomplete/RHFAutocomplete.jsx";
import { RHFAddressDetails } from "../../coding/rhfAddress/";
//** MOVE TO COMPONENT LIBRARY */

//----------------------------------------------------------------
//** Allow the user to switch between Address search and manual entry */

export default function AddressDetailsChoice({ ...props }) {
	const {
		accessToken,
		name = "missing-please-add",
		label = "Address",
		labelOption = "fullAddress",
		onAutoCompleteChange,
		autoCompleteLabelOption = "",
		autoCompleteName = "",
		showTitle = true,
		onChange,
		onSwitchView,
		dataSet,
		resetAll = false,
		handleAddressEntryType,
	} = { ...props };

	const nameFormatted = name.replaceAll("-", "");

	const [showAutoSearch, setShowAutoSearch] = useState(true);
	const [resetAllValues, setResetAllValues] = useState(resetAll);

	// const { handleEventChange, state } = useSharedData();

	const eventName = `${name}AutoComplete`;

	const handleAddressShow = () => {
		setShowAutoSearch(!showAutoSearch);
		onSwitchView(nameFormatted);
		setResetAllValues(true);
		handleAddressEntryType({ name: eventName, value: !showAutoSearch });
	};

	const handleLocalOnChange = (e, newVal) => {
		onChange(e);
	};

	useEffect(() => {
		const showAutoCompleteAddressEntry =
			dataSet?.[`${name}StreetName`] == null ||
			dataSet?.[`${name}StreetName`]?.length <= 0
				? true
				: false;
		setShowAutoSearch(showAutoCompleteAddressEntry);
	}, []);

	useEffect(() => {
		setResetAllValues(resetAll);
	}, [resetAll]);

	return (
		<OneColumnStack
			id={`${name}-id`}
			name={`${name}-stack`}
			sx={{ maxWidth: { xs: 636 } }}
		>
			<Section
				align="start"
				sx={{ justifyContent: "flex-start", alignContent: "flex-start" }}
				data-identifier={`${name}-section`}
			>
				{showTitle ? (
					<Typography variant="h5" mb={2}>
						Policy mailing address
					</Typography>
				) : null}
				{showAutoSearch ? (
					<RHFAutocomplete
						defaultValue={
							dataSet != null && resetAllValues === false
								? dataSet[`${nameFormatted}Full`]
								: ""
						}
						name={`${nameFormatted}Full`}
						accessToken={accessToken}
						func={useAutocompleteAddress}
						label={label}
						labelOption={labelOption}
						onChange={(e) => handleLocalOnChange(e)}
						freeSolo={false}
					/>
				) : null}
				{!showAutoSearch ? (
					<Section align="start">
						<RHFAddressDetails
							name={nameFormatted}
							dataSet={dataSet}
							resetAll={resetAllValues}
							accessToken={accessToken}
							useFunction={useFindSuburb}
							autoCompleteLabel="Postcode/Suburb"
							autoCompleteLabelOption={autoCompleteLabelOption}
							autoCompleteName={autoCompleteName}
							autoCompleteOChange={(e) => onAutoCompleteChange(e)}
							streetNumberType={streetNumberType}
							streetNameType={streetNameType}
						/>
					</Section>
				) : null}

				<Section align="start" onClick={handleAddressShow}>
					<Typography variant="p3-link" sx={{ fontSize: 14 }}>
						{showAutoSearch === true
							? "Can't find my address"
							: "Go back to address search"}
					</Typography>
				</Section>
			</Section>
		</OneColumnStack>
	);
}
